import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getPreviousPremiumsReports = options =>
  call(websocketFetch, 'get_premiums_export_reports', options);
